export const formatCurrency = (value, maximumFractionDigits = 0) =>
  new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    maximumFractionDigits
  }).format(Number.isFinite(value) ? value : 0);

export const formatNumber = (value) =>
  new Intl.NumberFormat('en-US', {
    maximumFractionDigits: 0
  }).format(Number.isFinite(value) ? value : 0);

export const calculateBudget = (items, settings) => {
  const activeItems = items.filter((item) => item.enabled);
  const baseSubtotal = activeItems.reduce(
    (sum, item) => sum + item.quantity * item.rate,
    0
  );
  const locationMultiplier = 1 + (settings.locationAdjustment || 0) / 100;
  const grossSubtotal = baseSubtotal * locationMultiplier;
  const locationImpact = grossSubtotal - baseSubtotal;
  const discount = grossSubtotal * (settings.discountRate / 100);
  const discountedSubtotal = grossSubtotal - discount;
  const contingency = discountedSubtotal * (settings.contingencyRate / 100);
  const taxableAmount = discountedSubtotal + contingency;
  const tax = taxableAmount * (settings.taxRate / 100);
  const total = taxableAmount + tax;

  const categories = activeItems.reduce((result, item) => {
    const value = item.quantity * item.rate * locationMultiplier;
    result[item.category] = (result[item.category] || 0) + value;
    return result;
  }, {});

  const convertedLeads =
    settings.projectedLeads * (settings.conversionRate / 100);
  const projectedValue = convertedLeads * settings.valuePerConversion;
  const roi = total > 0 ? ((projectedValue - total) / total) * 100 : 0;
  const costPerAttendee =
    settings.attendees > 0 ? total / settings.attendees : 0;
  const costPerLead =
    settings.projectedLeads > 0 ? total / settings.projectedLeads : 0;
  const remaining = settings.budgetCap - total;

  return {
    activeItems,
    baseSubtotal,
    grossSubtotal,
    locationImpact,
    locationMultiplier,
    discount,
    discountedSubtotal,
    contingency,
    tax,
    total,
    categories,
    convertedLeads,
    projectedValue,
    roi,
    costPerAttendee,
    costPerLead,
    remaining
  };
};